import IConstraints from '../../../types/IContraints';
import { isNullOrUndefined } from '../../../lib/typeGuards';

export const getAcceptString = (constraints: IConstraints | undefined): string => {
  if (isNullOrUndefined(constraints)) {
    return '';
  }
  return (constraints.fileExtensions || [])
    .map(extension => `.${extension}`)
    .concat(constraints.mimeTypes || [])
    .join(',');
};
